import PostDetailCourseSuggestion from '@/components/elements/feed/course-suggestion/post-detail-cousre-suggest';
import NewPost from '@/components/elements/feed/post/new-post/NewPost';
import { PATH_NAME } from '@/configs/pathName';
import {
  getFirst150Characters,
  removeBreakLinesAndSpaces,
} from '@/helpers/stringHelpers';
import { useSEO } from '@/hooks/useSEO';
import { useScreen } from '@/hooks/useScreen';
import cookieCommons from 'common/cookieCommons';
import Divider from 'design-system/components/Divider/Divider';
import { convert } from 'html-to-text';
import { GetServerSideProps } from 'next';
import { useRouter } from 'next/router';
import { useQuery } from 'react-query';
import { getPostDetail } from '../../apis/tms/post.api';
import { newDetailBEPostConvertToIPost } from '../../common/post/convertToIPost';
import { FEED_POST_DETAIL } from '../../constant/QueryKeyName';
import { INewPostDetailBE, IPost } from '../../interfaces/post.interface';
import FeedLayout from '../../layouts/FeedLayout/FeedLayout';

const Home = ({ data }: { data: INewPostDetailBE }) => {
  const router = useRouter();
  const { pid: postId } = router.query;

  const { isDesktop } = useScreen();

  // use this although we have getServerSideProps because use this to make refect data easier
  const { data: postData } = useQuery<INewPostDetailBE, Error, IPost>(
    [FEED_POST_DETAIL, postId],
    () => getPostDetail(postId as string),
    {
      initialData: data,
      enabled: !!postId,
      refetchOnMount: true,
      select(data) {
        return newDetailBEPostConvertToIPost(data);
      },
      onError: () => {},
    }
  );

  return (
    <FeedLayout hideTopNavOnScroll hideBottomBar={!isDesktop}>
      <div className="gap-4 xl:flex xl:px-10 xl:py-4 2xl:px-16">
        {postData && <NewPost {...postData} />}
        {!isDesktop && <Divider />}
        <PostDetailCourseSuggestion />
      </div>
    </FeedLayout>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  cookieCommons.setContext(context);
  const postId = context.params?.pid;

  try {
    const data = await getPostDetail(postId as string);

    const seo = JSON.parse(
      JSON.stringify(
        useSEO(data.title, {
          description: getFirst150Characters(
            removeBreakLinesAndSpaces(convert(data.content))
          ),
          image:
            data?.images[0] ||
            'https://i.pinimg.com/originals/68/3a/0a/683a0afbeedeaae759c5676861a787b9.jpg',
        })
      )
    );
    return {
      props: {
        data,
        seo,
      },
    };
  } catch (err) {
    return {
      redirect: {
        destination: PATH_NAME.NOT_FOUND,
        permanent: false,
      },
    };
  }
};

export default Home;
